export default {
  title: {
    historyList: "歷史列表",
    keySteps: "關鍵步驟",
  },
  buttons: {
    historyList: "歷史列表",
    keySteps: "關鍵步驟",
  },
};
